// import React, { useEffect, useState } from 'react'
// import Header from '../components/Header'
// import Footer from '../components/Footer'
// import { FaFacebookF } from 'react-icons/fa6'
// import { FaGoogle } from 'react-icons/fa6'
// import { Link, useNavigate } from 'react-router-dom'
// import { useDispatch, useSelector } from 'react-redux'
// import { customer_register, messageClear } from '../store/reducers/authReducer'
// import toast from 'react-hot-toast'
// import { FadeLoader } from 'react-spinners'

// const Register = () => {
//   const navigate = useNavigate()
//   const dispatch = useDispatch()
//   const { loader, errorMessage, successMessage, userInfo } = useSelector(
//     (state) => state.auth
//   )

//   const [state, setState] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     password: '',
//     userType: '',
//     address: '',
//     printHouseName: '',
//   })

//   const inputHandle = (e) => {
//     const { name, value, checked, type } = e.target

//     if (name === 'userType' && value !== state.userType) {
//       setState({
//         ...state,
//         userType: value,
//         address: '',
//         printHouseName: '',
//       })
//     } else {
//       setState({
//         ...state,
//         [name]: type === 'checkbox' ? checked : value,
//       })
//     }
//   }

//   const register = (e) => {
//     e.preventDefault()
//     dispatch(customer_register(state))
//   }

//   useEffect(() => {
//     if (successMessage) {
//       toast.success(successMessage)
//       dispatch(messageClear())
//     }
//     if (errorMessage) {
//       toast.error(errorMessage)
//       dispatch(messageClear())
//     }
//     if (userInfo) {
//       navigate('/')
//     }
//   }, [successMessage, errorMessage])

import React, { useEffect, useState } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { customer_register, messageClear } from '../store/reducers/authReducer'
import toast from 'react-hot-toast'
import { FadeLoader } from 'react-spinners'
import { auth } from '../firebase'
import {
  updateProfile,
  updatePassword,
  onAuthStateChanged,
} from 'firebase/auth'
import { useTranslation } from 'react-i18next'

const Register = () => {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language
  const isRTL = currentLanguage === 'ar' || currentLanguage === 'kr'
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const { loader, errorMessage, successMessage, userInfo } = useSelector(
    (state) => state.auth,
  )

  const initialEmail =
    location.state?.verifiedEmail ||
    localStorage.getItem('emailForRegistration') ||
    ''

  const [user, setUser] = useState(null)
  const [state, setState] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
    userType: 'user',
    address: '',
    printHouseName: '',
  })
  const fromPage = localStorage.getItem('fromPage')
  // Listen for firebase auth state changes
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser)

      if (fromPage === 'forgot') {
        navigate('/forgotPassword')
      } else {
        navigate('/register', { state: { verifiedEmail: initialEmail } })
      }
    })

    return () => unsubscribe()
  }, [initialEmail, navigate, fromPage])

  // Update email if location.state changes
  useEffect(() => {
    if (location.state?.verifiedEmail) {
      setState((prev) => ({ ...prev, email: location.state.verifiedEmail }))
    }
  }, [location])

  const inputHandle = (e) => {
    const { name, value, checked, type } = e.target

    if (name === 'userType' && value !== state.userType) {
      setState({
        ...state,
        userType: value,
        address: '',
        printHouseName: '',
      })
    } else {
      setState({
        ...state,
        [name]: type === 'checkbox' ? checked : value,
      })
    }
  }

  // const register = async (e) => {
  //   e.preventDefault()

  //   if (!user) {
  //     toast.error('User not signed in yet. Please wait a moment and try again.')
  //     return
  //   }

  //   try {
  //     await updateProfile(user, { displayName: state.name })

  //     if (state.password) {
  //       await updatePassword(user, state.password)
  //     }

  //     dispatch(
  //       customer_register({
  //         ...state,
  //         uid: user.uid,
  //         emailVerified: true,
  //       })
  //     )
  //   } catch (error) {
  //     toast.error(`Error updating profile: ${error.message}`)
  //   }
  // }

  const register = async (e) => {
    e.preventDefault()

    // if (auth.currentUser) {
    //   // User coming from email verification
    //   try {
    //     await updateProfile(auth.currentUser, { displayName: state.name })
    //     if (state.password) {
    //       await updatePassword(auth.currentUser, state.password)
    //     }

    //     // Dispatch to Redux with verified user data
    //     dispatch(
    //       customer_register({
    //         ...state,
    //         uid: auth.currentUser.uid,
    //         emailVerified: true,
    //       })
    //     )
    //   } catch (error) {
    //     toast.error(`Error updating profile: ${error.message}`)
    //   }
    // }
    // else {
    //   // Regular registration
    dispatch(customer_register(state))
    // }
  }

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage)
      dispatch(messageClear())
      window.localStorage.removeItem('emailForRegistration')
      return // stops here if successMessage exists
    }
    if (errorMessage) {
      toast.error(errorMessage)
      dispatch(messageClear())
      return // stops here if errorMessage exists
    }
    if (userInfo) {
      navigate('/')
    }
  }, [successMessage, errorMessage, userInfo, dispatch, navigate])

  return (
    <div>
      {loader && (
        <div className="w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]">
          <FadeLoader />
        </div>
      )}

      <Header />
      <div className="bg-slate-100 mt-4">
        <div className="w-full justify-center items-center p-10 sm:p-4">
          <div className="grid grid-cols-1 w-[30%] sm:w-full mx-auto bg-white rounded-md">
            <div className="px-8 py-8">
              <h2 className="text-center w-full text-xl text-slate-600 font-bold">
                {t('home.complete_register')}{' '}
              </h2>

              <div>
                <form onSubmit={register} className="text-slate-600">
                  <div className="flex flex-col gap-1 mb-2">
                    <label htmlFor="name">{t('home.name')}</label>
                    <input
                      onChange={inputHandle}
                      value={state.name}
                      className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-[#256398] rounded-md"
                      type="text"
                      name="name"
                      id="name"
                      placeholder="Name"
                      required
                    />
                  </div>

                  <div className="flex flex-col gap-1 mb-2">
                    <label htmlFor="email">{t('home.email')}</label>
                    <input
                      onChange={inputHandle}
                      value={state.email}
                      className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-[#256398] rounded-md"
                      type="email"
                      name="email"
                      id="email"
                      // required
                      // disabled
                    />
                  </div>

                  <div className="flex flex-col gap-1 mb-2">
                    <label htmlFor="phone">{t('home.phone')}</label>
                    <input
                      onChange={inputHandle}
                      value={state.phone}
                      className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-[#256398] rounded-md"
                      type="text"
                      name="phone"
                      id="phone"
                      placeholder="Phone"
                      required
                    />
                  </div>

                  <div className="flex flex-col gap-1 mb-2">
                    <label htmlFor="password">{t('home.password')}</label>
                    <input
                      onChange={inputHandle}
                      value={state.password}
                      className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-[#256398] rounded-md"
                      type="password"
                      name="password"
                      id="password"
                      placeholder="Password"
                      required
                    />
                  </div>

                  <div>
                    {/* Register as Print House Radio Button */}
                    {/* <div className="flex items-center gap-2 p-3">
                      <input
                        onChange={inputHandle}
                        checked={state.userType === 'printHouse'}
                        className="w-4 h-4"
                        type="radio"
                        name="userType"
                        value="printHouse"
                        id="printHouse"
                        required
                      />
                      <label htmlFor="printHouse" className="text-md">
                        {t('home.register_printhouse')}
                      </label>
                    </div> */}

                    {/* Register as User Radio Button */}
                    <div className="flex items-center gap-2 p-3">
                      <input
                        onChange={inputHandle}
                        checked={state.userType === 'user'}
                        className="w-4 h-4"
                        type="radio"
                        name="userType"
                        value="user"
                        id="user"
                        // required
                      />
                      <label htmlFor="user" className="text-md">
                        {t('home.user_register')}
                      </label>
                    </div>
                  </div>

                  <button className="px-8 w-full py-2 bg-primary shadow-lg hover:bg-[#256398] text-white rounded-md">
                    {auth.currentUser
                      ? ` ${t('home.register')}`
                      : ` ${t('home.register')}`}
                  </button>
                </form>
                <div className="flex justify-center items-center py-2">
                  <div className="h-[1px] bg-slate-300 w-[95%]"> </div>
                  <span className="px-3 text-slate-600">{t('home.or')}</span>
                  <div className="h-[1px] bg-slate-300 w-[95%]"> </div>
                </div>
              </div>

              <div className="text-center text-lg text-slate-600 pt-1">
                <p>
                  {t('home.already_have_account')}{' '}
                  <Link className="text-blue-500" to="/login">
                    {' '}
                    {t('home.login')}
                  </Link>{' '}
                </p>
              </div>

              {/* <a target="_blank" href="http://localhost:3001/login">
                <div className="px-8 w-full py-2 bg-[#02e3e0] shadow hover:shadow-red-500/50 text-white rounded-md flex justify-center items-center gap-2 mb-3">
                  Login As a Seller
                </div>
              </a> */}
            </div>

            {/* <div className="w-full h-full py-4 pr-4">
              <img src="http://localhost:3000/images/login.jpg" alt="" />
            </div> */}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default Register
